(() => {
  const config = document.querySelector('[data-foster-tracking]');
  if (!config || config.dataset.initialized) return;
  config.dataset.initialized = 'true';
  const measurementId = config.dataset.measurementId;
  const environment = config.dataset.themeRole === 'main' ? 'live' : 'preview';
  const query = new URLSearchParams(window.location.search);
  const hotspot = query.get('utm_source') === 'unifi' && query.get('utm_medium') === 'wifi' && query.get('utm_campaign') === 'east_lansing_rewards';
  const incomingCampaign = ['utm_source', 'utm_medium', 'utm_campaign'].some(key => query.has(key));
  const storageKey = 'foster_traffic_session_v1';
  const timeout = 30 * 60 * 1000;
  let origin = hotspot ? 'east_lansing_wifi' : 'regular_site';
  let ready = false;
  let sentPage = false;
  let sentArrival = false;
  let configured = false;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const persist = () => {
    if (!allowed()) return;
    try { sessionStorage.setItem(storageKey, JSON.stringify({ origin, lastActivity: Date.now() })); } catch (_) {}
  };
  const resolveOrigin = () => {
    if (!allowed()) return;
    if (!incomingCampaign) {
      try {
        const stored = JSON.parse(sessionStorage.getItem(storageKey));
        if (stored && Date.now() - stored.lastActivity < timeout && stored.origin === 'east_lansing_wifi') origin = stored.origin;
      } catch (_) {}
    }
    persist();
    config.dataset.trafficOrigin = origin;
  };
  const send = (name, extra = {}) => {
    if (!ready || !allowed()) return;
    persist();
    const data = {
      traffic_origin: origin,
      cafe_location: origin === 'east_lansing_wifi' ? 'east_lansing' : 'not_specified',
      entry_campaign: origin === 'east_lansing_wifi' ? 'east_lansing_rewards' : 'other',
      traffic_environment: environment,
      page_path: window.location.pathname,
      ...extra
    };
    try { window.Shopify?.analytics?.publish(name, data); } catch (_) {}
    if (/^G-[A-Z0-9]+$/.test(measurementId)) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      if (!configured) {
        configured = true;
        if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
          const script = document.createElement('script');
          script.async = true;
          script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId);
          document.head.append(script);
          window.gtag('js', new Date());
        }
        window.gtag('config', measurementId, { send_page_view: false });
      }
      window.gtag('event', name, { ...data, send_to: measurementId, transport_type: 'beacon', ...(environment === 'preview' ? { debug_mode: true } : {}) });
    }
    config.dataset.lastEvent = name;
    config.dataset.eventCount = String(Number(config.dataset.eventCount || 0) + 1);
    document.dispatchEvent(new CustomEvent('foster:tracking-published', { detail: { name, data } }));
  };
  const pageEvents = () => {
    if (!ready || !allowed()) return;
    if (!sentPage) {
      sentPage = true;
      send('foster_traffic_page_view');
      if (document.querySelector('.foster-rewards')) send('rewards_page_view');
    }
    if (hotspot && !sentArrival) { sentArrival = true; send('cafe_wifi_arrival'); }
  };
  const initialize = () => {
    ready = true;
    resolveOrigin();
    pageEvents();
  };
  document.querySelectorAll('[data-wifi-welcome]').forEach(node => { node.hidden = !hotspot; });
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (!link || !document.querySelector('.foster-rewards')) return;
    let url;
    try { url = new URL(link.href, window.location.href); } catch (_) { return; }
    if (!['squareup.com', 'profile.squareup.com'].includes(url.hostname) || !url.pathname.includes('loyalty')) return;
    const placement = link.dataset.rewardsCta || (link.closest('[data-wifi-welcome]') ? 'wifi_welcome' : 'reward_catalog');
    const tierPanel = link.closest('[role="tabpanel"]');
    const tier = tierPanel?.querySelector('h3')?.textContent.trim() || 'none';
    send(placement === 'account' ? 'rewards_account_click' : 'rewards_signup_click', { cta_placement: placement, tier_name: tier, destination: 'square_loyalty' });
  });
  document.addEventListener('foster:tier-selected', event => send('rewards_tier_select', { tier_name: event.detail.tier }));
  document.addEventListener('visitorConsentCollected', () => {
    if (allowed()) { resolveOrigin(); pageEvents(); }
    else { try { sessionStorage.removeItem(storageKey); } catch (_) {} }
  });
  if (window.Shopify?.customerPrivacy) initialize();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) initialize(); });
})();
